import React,{useState} from 'react';
import Form from 'react-bootstrap/Form';

const Checkbox = props => {
     const handleCheckbox =  (evt)  => {
      console.log(evt.target.checked);
      props.tierChangeHandler([props.tier, evt.target.checked]);
   }

   return (
          <div className="timeStyle box2" 
               style={{ fontSize:'16px', padding:'5px', marginRight:'5px', marginTop: '18px', color: 'white'}}>
              <Form>      
                <Form.Group  controlId="formBasicCheckbox">
                  <Form.Check onChange={handleCheckbox} type="checkbox" label={props.tier} />
                </Form.Group>
              </Form>
          </div>
         
   );
}

export default Checkbox;